import { PreventativeCareItem } from 'store/preventativeCare/types';
import { AdvisoryReferenceCDType } from 'lib/dashboard/types';

export const isPreventiveCareItemDue = (item: PreventativeCareItem) =>
  item?.status?.toLowerCase() === 'due';

export const filterAdultFluAdvisory = (item: PreventativeCareItem) =>
  item?.referenceCd !== AdvisoryReferenceCDType.INFLUENZA_VACCINATION_CURRENT_SEASON &&
  item?.referenceCd !== AdvisoryReferenceCDType.FLU_VACCINE_9;

export const getProviderName = (providerNames: string[]) =>
  providerNames?.[0] || 'Provider Not Available';
